import React from 'react';
import { ZuiErrorPage } from 'components/Zui/ZuiErrorPage';

export type StatusCode = '400' | '401' | '403' | '404' | '500';

export const ERROR_TEXT = {
  401: {
    header: '',
    message:
      "Login to try accessing the page. If you're still having issues, contact <a href='https://support.zywave.com'>Zywave support</a>.",
  },
  403: {
    header: 'You do not have permission to access this page',
    message:
      "Switch profiles to log in as a different user that has access. If you're still having issues, contact <a href='https://support.zywave.com'>Zywave support</a>.",
  },
  404: {
    header: 'The page may no longer exist or the URL may be incorrect',
    message:
      "Check the URL or try coming back later. If you're still having issues, contact <a href='https://support.zywave.com'>Zywave support</a>.",
  },
  500: {
    header: 'The server encountered an internal error',
    message:
      "Try coming back later or refreshing the page. If you're still having issues, contact <a href='https://support.zywave.com'>Zywave support</a>.",
  },
};

export default function InternalError({
  statusCode = '500' as StatusCode,
}: {
  statusCode?: StatusCode;
}) {
  let errorCode = statusCode;
  // If the error code is 400, change it to 500.
  if (errorCode === '400') {
    errorCode = '500';
  }

  // Update the default value of statusCode
  const errorText = ERROR_TEXT[parseInt(errorCode) as keyof typeof ERROR_TEXT];

  const header: string = errorText?.header ? errorText.header : '';
  const message: string = errorText?.message ? errorText.message : '';

  return <ZuiErrorPage error={errorCode} header={header} message={message} />;
}
